import React, { Fragment } from 'react';
import joi from 'joi-browser';
import Redirect from 'react-router-dom/Redirect';
import { Form, Alert } from 'antd';
import { connect } from 'react-redux';
import BaseForm from '../../components/BaseForm';
import { login } from '../../modules/auth';
import './Login.css';
import logo from '../../assets/images/logo-dark.svg';

class Login extends BaseForm {
  validationSchema = {
    email: joi.string().email().trim().required(),
    password: joi.string().min(6).required(),
  };

  render() {
    const { isLoading, user, error } = this.props;

    if (user) {
      return <Redirect to="/" />;
    }

    return (
      <Form className="form" layout="vertical" onSubmit={this.onSubmit}>
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        {error && <Alert type="error" message={error} />}
        {this.renderInput('email', true, 'Email', null, null, null, null)}
        {this.renderInput('password', true, 'Password', null, 'password', null, null)}
        {this.renderSubmitButton('Log In', isLoading)}
      </Form>
    );
  }
}

export default connect(state => state.auth, { onSubmit: login })(Login);




// WEBPACK FOOTER //
// ./src/containers/Login/index.js